const React = require('react');


module.exports = (props) => {
  const t = Math.floor(props.time * 0.001);
  return t ? (
    <span
      className="pl5"
    >{'' + Math.floor(t / 60) + ':' + ('' + (t % 60)).padStart(2, '0')}</span>
  ) : null;
};
